<template>
  <section class="text" :class="{'has-after': item.headline}">
    <div class="wrap">
      <h2 class="headline" v-if="item.headline">{{ item.headline }}</h2>
      <div class="content-body" v-html="item.body"></div>
    </div>
  </section>
</template>

<script>
import AbstractSection from './abstract'

export default AbstractSection.extend({

})
</script>

<style lang="scss" scoped>
/* Import from Spar Nord Assets */
@import '~@styles/global/index';
@import '~@styles/colors/variables';
@import '~@styles/mq/variables';
@import '~@styles/mixins/index';
@import '~@animations/easings/variables';
@import '~@animations/durations/variables';

@import '~@helpers/grid';
@import '~@helpers/no-drag';

.text {
  position: relative;

  @media #{$above-breakpoint-768} {

    &.has-after {
      &:after {
        content: "";
        display: block;

        height: 100%;
        width: 140px;

        position: absolute;
        right: 0;
        top: 50%;

        transform: translateY(-50%);

        background: url('https://d2ffutrenqvap3.cloudfront.net/items/1E0r1Z0z0C3N0Y0b0a38/5%20element-outline-05.svg');
        background-repeat: no-repeat;
        background-position: center right;
        background-size: cover;
      }
    }

    .wrap > * {
      margin-right: 150px;

      @media #{$above-breakpoint-768} {
        margin-left: calc(#{$global-padding} * 6);
        max-width: 700px;
      }
    }
  }
}

h2.headline {
  @include font-size(22px, 30px);
  font-weight: bold;

  margin-bottom: calc(#{$global-padding} * 1.25);

  &:before {
    content: "";
    display: block;
    margin-bottom: $global-padding;

    background: $color-red;
    height: 10px;
    width: 74px;
  }

}

p {
  @include font-size(16px, 18px);
  line-height: 1.4;

  + p {
    margin-top: $global-padding;
  }
}
</style>

<style lang="scss">
  /* Import from Spar Nord Assets */
  @import '~@styles/global/index';
  @import '~@styles/colors/variables';
  @import '~@styles/mq/variables';
  @import '~@styles/mixins/index';
  @import '~@animations/easings/variables';
  @import '~@animations/durations/variables';

  p {
    @include font-size(16px, 18px);
    line-height: 1.4;

    + p {
      margin-top: $global-padding;
    }
  }
</style>



// WEBPACK FOOTER //
// src/sections/text.vue